
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.1030"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1030",
    "ar-eg": "static-7.1030",
    "bg": "static-7.1030",
    "bn": "static-7.1030",
    "ca-es": "static-7.1030",
    "cs": "static-7.1030",
    "da": "static-7.1030",
    "de": "static-7.1030",
    "el": "static-7.1030",
    "en-gb": "static-7.1030",
    "en": "static-7.1030",
    "es-mx": "static-7.1030",
    "es": "static-7.1030",
    "et": "static-7.1030",
    "fi": "static-7.1030",
    "fr-ca": "static-7.1030",
    "fr": "static-7.1030",
    "he-il": "static-7.1030",
    "hi": "static-7.1030",
    "hr": "static-7.1030",
    "hu": "static-7.1030",
    "id": "static-7.1030",
    "it": "static-7.1030",
    "ja": "static-7.1030",
    "ko": "static-7.1030",
    "lt": "static-7.1030",
    "ms": "static-7.1030",
    "nl": "static-7.1030",
    "no": "static-7.1030",
    "pl": "static-7.1030",
    "pt-br": "static-7.1030",
    "pt-pt": "static-7.1030",
    "ro": "static-7.1030",
    "ru": "static-7.1030",
    "sk": "static-7.1030",
    "sl": "static-7.1030",
    "sv": "static-7.1030",
    "th": "static-7.1030",
    "tl": "static-7.1030",
    "tr": "static-7.1030",
    "uk": "static-7.1030",
    "vi": "static-7.1030",
    "x-pseudo": "static-7.1030",
    "zh-cn": "static-7.1030",
    "zh-hk": "static-7.1030",
    "zh-tw": "static-7.1030"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.1030'}); }
})();


